module.exports = __webpack_public_path__ + "static/media/Dephiana.f24e0bd2.ttf";